import { render, staticRenderFns } from "./LeaveRequestClosed.vue?vue&type=template&id=25fbe365"
import script from "./LeaveRequestClosed.vue?vue&type=script&lang=js"
export * from "./LeaveRequestClosed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports